import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import AxisControllers from './AxisControllers';
import LabelControllers from './LabelControllers';

const Controllers = ({
  config = undefined,
  data = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  selectedLine = undefined,
  selectedColumn = undefined,
  selectedFunction = undefined,
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
}) => (
  <>
    {[GeneralControllers, LabelControllers, AxisControllers].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedLine={selectedLine}
        selectedColumn={selectedColumn}
        selectedFunction={selectedFunction}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.shape({}),
  selectedLine: PropTypes.shape({}),
  selectedFunction: PropTypes.shape({}),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
};

export default Controllers;
